import 'reflect-metadata';
import { plainToClass } from "class-transformer";
import { DrawCabinet } from '$src/CGS/domain/dto/article/Cabinet/DrawCabinet';
import { CabinetGeneratorFactory } from '../../Cabinet/CabinetGeneratorFactory ';
import { CabinetObject } from '../../Cabinet/Objects/CabinetObject';

export class CabinetS1PulloutTest {

    private jsonData = {"$id":"1","Constants":{"$id":"2","GapTopBox":"0","GapBottomBox":"0","PlinthHeight":"150","GapBetweenFrontElements":"3","SideBoxGap":"3","GrooveGap":"30","BoxThickness":"16","DoorThickness":"20","ShelfThickness":"16","GlassShelfThickness":"6","FixedShelfThickness":"16","DrawerRecess":"100","DrawerRailHeight":"100","PulloutRecess":"100","PulloutRailHeight":"200","PlinthDepth":"60","GrooveWidth":"60","CountertopHeight":"720"},"Fronts":[{"$id":"3","Faces":[{"$id":"4"}],"Element":{"$id":"5","Elements":[{"$id":"6","TypeName":"DrawFrontPullOut","FrontElement":2,"Height":"285","Width":"Auto"},{"$id":"7","TypeName":"DrawFrontDrawer","FrontElement":3,"Height":"141","Width":"Auto"},{"$id":"8","TypeName":"DrawFrontDrawer","FrontElement":3,"Height":"141","Width":"Auto"}],"TypeName":"DrawCabinetFrontElementGroup","Height":"Auto"}}],"CabinetShape":{"Width":"600","Depth":"461","Height":"576","Orientation":3,"TypeName":"DrawS1CabinetShape"},"TypeName":"DrawCabinet","Range":{"$id":"9","Name":"Classic","HasHandles":true,"IsWithGaps":true,"Id":"84aa120e-f3de-43b5-8211-44f8737454bc"},"ProviderRef":"U2SA 60 -58","SubFinish":{"$id":"10","Id":"31fbc7b7-62e8-4d04-93fe-c891dcfcf48f"},"ElementSubType":{"$id":"11","Name":"CabinetBox","Id":"dabe3eca-d308-4938-80fe-d8ee3f229506"},"Shape":{"$id":"12","Width":"600","Depth":"461","Height":"576","Orientation":3,"TypeName":"DrawS1CabinetShape"},"Id":"f9ee81b9-9af5-4aed-8b67-4a9d4a87cf0d"};


    getCabinet() : CabinetObject | undefined {
        let drawCabinet = this.getDrawCabinet();

        const generator = CabinetGeneratorFactory.GetGenerator(drawCabinet);
        const cabinetObject = generator?.BuildCabinet();

        return cabinetObject;
    }

    getDrawCabinet(): DrawCabinet {

        const deserializedObject = plainToClass(DrawCabinet, this.jsonData);

        return deserializedObject;
    }

}